import { render } from "./Regional.vue?vue&type=template&id=3ebf1418"
import script from "./Regional.vue?vue&type=script&lang=js"
export * from "./Regional.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__